var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronUp = function SvgChevronUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6608 29.262C33.424 30.0193 34.6636 30.0193 35.4268 29.262C35.6083 29.0825 35.7526 28.8686 35.851 28.6328C35.9494 28.3971 36 28.144 36 27.8884C36 27.6329 35.9494 27.3798 35.851 27.144C35.7526 26.9083 35.6083 26.6944 35.4268 26.5149L22.3827 13.5684C22.0142 13.2041 21.5174 13 20.9997 13C20.482 13 19.9852 13.2041 19.6167 13.5684L6.57268 26.5161C6.39127 26.6956 6.24724 26.9094 6.14892 27.145C6.05062 27.3808 6 27.6336 6 27.889C6 28.1445 6.05062 28.3973 6.14892 28.6331C6.24724 28.8687 6.39127 29.0825 6.57268 29.262C7.33708 30.0193 8.57668 30.0193 9.33989 29.262L21.0003 17.6884L32.6608 29.262Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevronUp.220c2f6ec10a4ad10741938d979f95cf.svg";